const resumeObj = {
  professional: {
    info: "Professional Info",
    infoP: "Greetings"
  },
  workCircle: {
    title: "Work Experience",
    job1: {
      workTitle: "Freelance, Kyrenia, CYP — Frontend Web Developer",
      workYear: "July 2019 - PRESENT"
    }, 
    job2: {
      workTitle: "CENI, Kinshasa, DRC — Data Entry Operator",
      workYear: "November  2010 - December 2010"
    }
  },
  education: {
    title: "Education",
    bachelor: {
      university: "Girne American University, Kyrenia, Kyrenia, Northern Cyprus — Bsc. Computer Engineering",
      bachelorYear: "Sept.  2016 -  2020"
    },
    highSchool: {
      degree: "C.S Ngemba, Kinshasa, DRC — High School Diploma",
      degreeYear: "2001 -  2007"
    }
  },
  skills: {
    title: "Skills",
    skillsTitle: {
      reactjs: "React JS",
      python: "Python",
      javascript: "Javascript",
      css: "CSS3",
      sql: "SQL",
      html: "Html5"
    }
  },
  languages: {
    title: "Languages",
    languageTitles: {
      french: "French - Fluently",
      lingala: "Lingala - Fluently",
      english: "English - Fluently"
    }
  }
};

export default resumeObj;